import * as React from 'react';
import { Button, FormField, Toaster } from '../../components';

import { ICusCancellationFormData } from './cus-cancellation-form.data';
import { ICusCancellationFormProps } from './cus-cancellation-form.props.autogenerated';
import { useCancellationForm, useCancellationFormRequests } from './hooks';

export interface ICusCancellationFormViewProps extends ICusCancellationFormProps<ICusCancellationFormData> {}

export default function CusCancellationForm(props: ICusCancellationFormViewProps) {
    const { config, context, resources } = props;

    const { formData, updateFormData, errors, isValid, clearFormData } = useCancellationForm(resources);
    const {
        submitCancellationForm,
        isToasterOpen,
        setIsToasterOpen,
        isFormLoading,
        isFormSubmitted,
        errorMessage
    } = useCancellationFormRequests(formData, context, resources, clearFormData, config.supportEmail ?? '');

    if (!config.supportEmail) {
        return null;
    }

    if (isFormSubmitted) {
        return (
            <section className='bs-support-success'>
                <div className='bs-support-success__card'>
                    <div className='bs-support-success__icon' aria-hidden='true'>
                        ✓
                    </div>
                    <p className='bs-support-success__message'>{resources.cancellationFormSuccessExtendedMessage}</p>
                </div>
            </section>
        );
    }

    return (
        <form className='bs-form'>
            <h1 className='bs-form__title'>{resources.cancellationFormTitle}</h1>

            <div className='bs-form__row'>
                <FormField
                    label={resources.orderLookupEmailLabel}
                    placeholder={resources.cancellationFormEmailPlaceholder}
                    value={formData.email}
                    onChange={e => updateFormData('email', e.target.value)}
                    error={errors['email'] as string | undefined}
                    inputType='email'
                    autocomplete='email'
                    name={resources.orderLookupEmailLabel}
                />
            </div>

            <div className='bs-form__row'>
                <FormField
                    label={resources.orderLookupOrderNumberLabel}
                    placeholder={resources.cancellationFormOrderNumberPlaceholder}
                    value={formData.orderNumber}
                    onChange={e => updateFormData('orderNumber', e.target.value)}
                    error={errors['orderNumber'] as string | undefined}
                    name={resources.orderLookupOrderNumberLabel}
                />
            </div>

            <Button onClick={submitCancellationForm} disabled={!isValid} isLoading={isFormLoading}>
                {resources.cancellationFormSubmitLabel}
            </Button>

            {errorMessage && <p role='alert'>{errorMessage}</p>}

            {isToasterOpen && (
                <Toaster type='success' message={resources.cancellationFormSuccessMessage} onClose={() => setIsToasterOpen(false)} />
            )}
        </form>
    );
}
